module.exports = __webpack_public_path__ + "img/zm-text.b353f495.png";